/**
 * The one call this client makes to the model directly: reading a reference picture.
 *
 * Everything else that thinks — planning, building, editing — happens server-side behind
 * /plan and /build. This is the exception because the picture is in the browser and the
 * answer is a look, not an app.
 *
 * Its own origin (a Lambda Function URL, like the build service) and therefore its own entry
 * in the CSP's connect-src. A blocked request here surfaces as a plain network error with
 * nothing naming CSP, which is why the origin is asserted at startup rather than discovered.
 */
import { request } from './client';

/** A vision call is slower than a data call and much faster than a build. */
const VISION_TIMEOUT_MS = 90_000;

export async function generate(input: {
  systemPrompt: string;
  messages: { role: 'user' | 'assistant'; content: string }[];
  /** A base64 data URI. The proxy downscales it again on the way to the model. */
  image?: string;
  structured?: boolean;
}): Promise<{ content: string }> {
  return request<{ content: string; creditsRemaining?: number }>('/llm', {
    base: 'llm',
    method: 'POST',
    timeoutMs: VISION_TIMEOUT_MS,
    body: {
      systemPrompt: input.systemPrompt,
      messages: input.messages,
      firstBuild: false,
      structured: input.structured ?? false,
      ...(input.image ? { image: input.image } : {}),
    },
  });
}
